export default "__VITE_ASSET__Dv$4yTxb__"